import styled from 'styled-components';
import { theme } from '@frameio/vapor';

const Container = styled.div<{ $size: number }>`
  border-radius: ${theme.radii[6]};
  height: ${({ $size }) => `${$size}px`};
  outline: none;
  width: ${({ $size }) => `${$size}px`};
`;

type IconProps = {
  lockColor: string;
  plusColor: string;
  customSize?: number;
};

function IconLockDualColor({
  lockColor,
  plusColor,
  customSize = 24,
}: IconProps) {
  return (
    <Container $size={customSize}>
      <svg
        fill="none"
        height={customSize}
        viewBox="0 0 24 24"
        width={customSize}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 8V7C16 4.70353 14.1966 3.00391 12 3.00391C9.80337 3.00391 8 4.70353 8 7V8H7.75C6.23122 8 5 9.23122 5 10.75V17.25C5 18.7688 6.23122 20 7.75 20H10.25C10.6642 20 11 19.6642 11 19.25C11 18.8358 10.6642 18.5 10.25 18.5H7.75C7.05964 18.5 6.5 17.9404 6.5 17.25V10.75C6.5 10.0596 7.05964 9.5 7.75 9.5H16.7109C17.1467 9.5 17.5 9.85329 17.5 10.2891C17.5 10.7033 17.8358 11.0391 18.25 11.0391C18.6642 11.0391 19 10.7033 19 10.2891C19 9.02487 17.9751 8 16.7109 8H16ZM12 4.50391C10.6066 4.50391 9.5 5.55689 9.5 7V8H14.5V7C14.5 5.55689 13.3934 4.50391 12 4.50391Z"
          fill={lockColor}
          fillRule="evenodd"
        />
        <path
          d="M16.6926 15.2933L17.2606 13.1834C17.3265 12.9389 17.6735 12.9389 17.7394 13.1834L18.3074 15.2933C18.4911 15.9757 19.0243 16.5089 19.7067 16.6926L21.8166 17.2606C22.0611 17.3265 22.0611 17.6735 21.8166 17.7394L19.7067 18.3074C19.0243 18.4911 18.4911 19.0242 18.3074 19.7067L17.7394 21.8166C17.6735 22.0611 17.3265 22.0611 17.2606 21.8166L16.6926 19.7067C16.5089 19.0243 15.9758 18.4911 15.2933 18.3074L13.1834 17.7394C12.9389 17.6735 12.9389 17.3265 13.1834 17.2606L15.2933 16.6926C15.9757 16.5089 16.5089 15.9758 16.6926 15.2933Z"
          fill={plusColor}
          fillRule="evenodd"
        />
      </svg>
    </Container>
  );
}

export function IconLockFeatureGate({ isActive = false, customSize = 24 }) {
  const iconColor = theme.colors.icon.interactive;

  return (
    <IconLockDualColor
      customSize={customSize}
      lockColor={iconColor[isActive ? 'hover' : 'off']}
      plusColor={iconColor[isActive ? 'on' : 'off']}
    />
  );
}
